import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGem,
  faGavel,
  faTags,
  faStar,
  faArrowRight,
  faArrowUpRightFromSquare,
  faCrown,
  faPlusSquare,
  faArrowUpFromBracket,
  faUserPlus,
  faTrophy,
  faGift,
  faTruckFast,
  faCommentDots,
  faHeart,
  faShieldHalved,
  faBoxOpen,
  faQuoteLeft,
  faStar as faStarSolid,
  faTimes,
  faCircleQuestion,
  faCreditCard,
  faRotate,
  faHeadset,
  faComments,
  faPaperPlane,
  faVideo,
  faFire,
  faClock,
  faVolumeUp,
  faVolumeMute,
  faUsers,
  faSpinner,
  faCheck,
  faWandMagicSparkles,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// eslint-disable-next-line no-unused-vars
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import instance from "../apiInstance";
import config from "../config";
import { appCopy, localizeStories } from "./appCopy";
import { formatAuctionImageUrl, LUXURY_FALLBACK_IMAGE } from "../imageUrl";
import { isAdminUser, isFeatureTester } from "../adminEmails";
import { showEnClient } from "../enClientFlags";
import { isSisterStore } from "../sisterStore";
import { openTestimonialWhatsApp, getVendasUrl } from "../openVendas";
import { getMySpins } from "../api/dashboard";
import { getMyTestimonial } from "../api/auth";
import { prefetchPromos } from "../promosCache";
import PromoGenieModal, { shouldAutoOpenGenie } from "../components/PromoGenieModal";
import { TesteeAppDock } from "../components/StoryCartDock";
import axios from "axios";
import store from "../store";
import googleplay from "../images/google-play.png";
import appstore from "../images/app-store.png";
import android from "../images/android.png";
import ios from "../images/ios.png";
import shareIconAndroid from "../images/share-icon-android.png";
import "./HomeLuxWhiteGold.css";
import "./HomeLuxWhiteGoldEnded.css";

const SLIDE_DURATION = 5000;

const STORIES_DATA = [
  {
    id: "leilao",
    label: "Leilão",
    icon: faGavel,
    gradient: "linear-gradient(135deg, #D4AF37, #8B6914)",
    live: true,
    slides: [
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #2d1a0a 100%)",
        icon: faGavel,
        title: "Leilão Aberto!",
        text: "Tem leilão rolando agora! Peças exclusivas de grife com lances a partir de R$1. Não perca essa oportunidade única.",
      },
      {
        bg: "linear-gradient(135deg, #2d1a0a 0%, #1a1a1a 100%)",
        icon: faStar,
        title: "Como Participar?",
        text: "1. Acesse a seção Leilões\n2. Escolha a peça desejada\n3. Faça seu lance\n4. Acompanhe em tempo real e arremate!",
      },
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #2a1a0a 100%)",
        icon: faGem,
        title: "Peças de Grife",
        text: "Bolsas, acessórios e itens raros das melhores marcas do mundo. Tudo autenticado e com preços que só o leilão oferece.",
      },
    ],
  },
  {
    id: "achados",
    label: "Achados",
    icon: faHeart,
    gradient: "linear-gradient(135deg, #B8962E, #D4AF37)",
    slides: [
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #2d2418 100%)",
        icon: faGem,
        title: "Curadoria Exclusiva",
        text: "Nossas personal shoppers selecionam as melhores peças do mercado de luxo para você.",
      },
      {
        bg: "linear-gradient(135deg, #2d2418 0%, #1a1a1a 100%)",
        icon: faStar,
        title: "Peças Raras",
        text: "Achados que você não encontra em qualquer lugar. Modelos limitados e edições especiais.",
      },
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #3a2e1a 100%)",
        icon: faTags,
        title: "Preços Especiais",
        text: "Descontos exclusivos para membros. Economize até 40% em peças de grife autenticadas.",
      },
    ],
  },
  {
    id: "depoimentos",
    label: "Clientes",
    icon: faCommentDots,
    gradient: "linear-gradient(135deg, #C19B2C, #8B6914)",
    slides: [
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #2a1a2a 100%)",
        icon: faQuoteLeft,
        title: '"Amei minha bolsa!"',
        text: "\"Chegou super rápido e exatamente como nas fotos. Qualidade impecável! Já estou de olho na próxima.\" — Ana C.",
        stars: 5,
      },
      {
        bg: "linear-gradient(135deg, #2a1a2a 0%, #1a1a1a 100%)",
        icon: faQuoteLeft,
        title: '"Atendimento nota 10"',
        text: "\"A equipe da Madamy é incrível, me ajudaram a escolher o presente perfeito. Super atenciosas!\" — Juliana M.",
        stars: 5,
      },
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #1a2a2a 100%)",
        icon: faQuoteLeft,
        title: '"Virei cliente fiel"',
        text: "\"Terceira compra e cada vez melhor. Peças originais, preços justos e entrega impecável. Recomendo!\" — Carla R.",
        stars: 5,
      },
    ],
  },
  {
    id: "envios",
    label: "Envios",
    icon: faTruckFast,
    gradient: "linear-gradient(135deg, #D4AF37, #A88526)",
    slides: [
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #2d2418 100%)",
        icon: faTruckFast,
        title: "Enviamos para todo o Brasil",
        text: "Entregas rápidas e seguras com rastreamento completo. Seu pedido chega embalado com todo carinho.",
      },
      {
        bg: "linear-gradient(135deg, #2d2418 0%, #1a1a1a 100%)",
        icon: faBoxOpen,
        title: "Embalagem Premium",
        text: "Cada peça é embalada com cuidado especial, como um presente de luxo que você merece.",
      },
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #3a2e1a 100%)",
        icon: faShieldHalved,
        title: "100% Seguro",
        text: "Todas as peças são autenticadas e enviadas com seguro. Sua compra protegida do início ao fim.",
      },
    ],
  },
  {
    id: "duvidas",
    label: "Dúvidas",
    icon: faCircleQuestion,
    gradient: "linear-gradient(135deg, #8B6914, #D4AF37)",
    slides: [
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #1a2028 100%)",
        icon: faCircleQuestion,
        title: "Como funciona?",
        text: "Somos um personal shopper de luxo. Selecionamos as melhores peças do mercado e trazemos com preços exclusivos para você. Tudo 100% original e autenticado.",
      },
      {
        bg: "linear-gradient(135deg, #1a2028 0%, #1a1a1a 100%)",
        icon: faCreditCard,
        title: "Formas de pagamento",
        text: "Aceitamos PIX, cartão de crédito em até 12x e boleto bancário. Pagamento seguro e protegido. Escolha a melhor opção para você!",
      },
      {
        bg: "linear-gradient(135deg, #1a1a1a 0%, #201a28 100%)",
        icon: faRotate,
        title: "Trocas e devoluções",
        text: "Você tem 7 dias para solicitar troca ou devolução após receber o produto. Basta entrar em contato com nosso suporte. Simples e sem burocracia!",
      },
      {
        bg: "linear-gradient(135deg, #201a28 0%, #1a1a1a 100%)",
        icon: faHeadset,
        title: "Fale conosco",
        text: "Tem alguma dúvida? Nossa equipe está pronta para te ajudar pelo WhatsApp ou Instagram. Atendimento rápido e humanizado, como você merece!",
      },
    ],
  },
];

const HomeLuxWhiteGold = () => {
  const t = appCopy(config.STORE_LOCALE);
  const [androidModal, setAndroidModal] = useState(false);
  const [iosModal, setIosModal] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [testimonialModal, setTestimonialModal] = useState(false);
  const [testimonialSent] = useState(false);
  const [myTestimonial, setMyTestimonial] = useState(null);
  const [loadingTestimonial] = useState(false);
  const [activeStory, setActiveStory] = useState(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);
  const startTimeRef = useRef(null);
  const storyVideoRef = useRef(null);
  const [storyMuted, setStoryMuted] = useState(true);
  const [videoLoading, setVideoLoading] = useState(false);
  const [storyVideos, setStoryVideos] = useState({});
  const videoBlobsRef = useRef({});
  const [spinData, setSpinData] = useState(null);
  const [activeAuctions, setActiveAuctions] = useState([]);
  const [endedTodayAuction, setEndedTodayAuction] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [labOpen, setLabOpen] = useState(false);
  const [genieOpen, setGenieOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    instance.get("/me")
      .then((res) => {
        const user = res.data?.user;
        const email = user?.email;
        setIsAdmin(isAdminUser(user));
        setLabOpen(res.data?.auction_lab_access ?? isFeatureTester(email));
      })
      .catch(() => {});
  }, []);

  // Background prefetch de Super Promos (dados + imagens + chunk JS) para abertura instantânea
  useEffect(() => {
    const timer = setTimeout(() => {
      prefetchPromos();
      import("./SuperPromos");
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!labOpen) {
      setActiveAuctions([]);
      setEndedTodayAuction(null);
      return undefined;
    }
    const loadAuctions = () => {
      instance
        .get("/auctions/today")
        .then((res) => {
          setActiveAuctions(res.data?.active || []);
          const ended = res.data?.ended_today || [];
          setEndedTodayAuction(ended.length > 0 ? ended[0] : null);
        })
        .catch(() => {
          instance
            .get("/auctions/active", { params: { limit: 3 } })
            .then((res) => {
              setActiveAuctions(res.data || []);
              setEndedTodayAuction(null);
            })
            .catch(() => {});
        });
    };
    loadAuctions();
    const onVisible = () => {
      if (document.visibilityState === "visible") loadAuctions();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [labOpen]);

  useEffect(() => {
    try {
      const cached = localStorage.getItem("storyVideos");
      if (cached) {
        const parsed = JSON.parse(cached);
        const today = new Date().toISOString().slice(0, 10);
        if (parsed.date === today && parsed.stories) {
          setStoryVideos(parsed.stories);
        }
      }
    } catch {}

    fetch(`${config.API_URL}/story_videos`)
      .then((r) => r.json())
      .then((data) => {
        if (data.stories) {
          setStoryVideos(data.stories);
          localStorage.setItem("storyVideos", JSON.stringify(data));
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    getMySpins()
      .then((data) => setSpinData(data))
      .catch(() => {});

    getMyTestimonial()
      .then((res) => {
        if (res && res.testimonial) {
          setMyTestimonial(res.testimonial);
        } else {
          setMyTestimonial(null);
        }
      })
      .catch(() => setMyTestimonial(null));
  }, []);

  const pendingPrize = useMemo(() => {
    if (!spinData?.history) return null;
    return spinData.history.find((h) => h.status === "pending") || null;
  }, [spinData]);

  const stories = useMemo(() => {
    const hasLeilaoStory = labOpen && (activeAuctions.length > 0 || !!endedTodayAuction);
    const mapped = STORIES_DATA.filter((story) => story.id !== "leilao" || hasLeilaoStory).map((story) => {
      if (story.id === "leilao" && activeAuctions.length > 0) {
        const auctionSlides = activeAuctions.map((auc) => ({
          auction: true,
          imageUrl: formatAuctionImageUrl(auc.images?.[0]),
          title: auc.title,
          price: auc.current_price,
          storePrice: auc.store_price,
          discountPercent: auc.discount_percent,
          auctionId: auc._id || auc.id,
          endTime: auc.end_time,
          totalBids: auc.total_bids || 0,
        }));
        return {
          ...story,
          live: true,
          slides: auctionSlides,
        };
      }
      if (story.id === "leilao" && endedTodayAuction && activeAuctions.length === 0) {
        return {
          ...story,
          live: false,
          slides: [{
            auction: true,
            imageUrl: formatAuctionImageUrl(endedTodayAuction.images?.[0]),
            title: endedTodayAuction.title,
            price: endedTodayAuction.winner_amount || endedTodayAuction.current_price,
            storePrice: endedTodayAuction.store_price,
            auctionId: endedTodayAuction._id || endedTodayAuction.id,
            endedToday: true,
            winnerName: endedTodayAuction.winner_name,
          }],
        };
      }
      const videos = storyVideos[story.id];
      if (videos && videos.length > 0) {
        return {
          ...story,
          slides: videos.map((url) => ({ videoUrl: url })),
        };
      }
      return story;
    });
    return localizeStories(mapped, config.STORE_LOCALE);
  }, [storyVideos, activeAuctions, endedTodayAuction, labOpen]);

  const closeStory = useCallback(() => {
    if (storyVideoRef.current) {
      storyVideoRef.current.pause();
    }
    setActiveStory(null);
    setSlideIndex(0);
    setProgress(0);
    if (timerRef.current) cancelAnimationFrame(timerRef.current);
  }, []);

  const goNextSlide = useCallback(() => {
    if (activeStory === null) return;
    const story = stories[activeStory];
    if (!story) { closeStory(); return; }

    const nextIndex = slideIndex + 2;
    if (nextIndex < story.slides.length && story.slides[nextIndex].imageUrl) {
      const img = new Image();
      img.src = story.slides[nextIndex].imageUrl;
      img.decode().catch(() => {});
    }

    if (slideIndex < story.slides.length - 1) {
      setSlideIndex((i) => i + 1);
      setProgress(0);
      startTimeRef.current = null;
    } else if (activeStory < stories.length - 1) {
      setActiveStory((s) => s + 1);
      setSlideIndex(0);
      setProgress(0);
      startTimeRef.current = null;
    } else {
      closeStory();
    }
  }, [activeStory, slideIndex, stories, closeStory]);

  const goPrevSlide = useCallback(() => {
    if (slideIndex > 0) {
      setSlideIndex((i) => i - 1);
      setProgress(0);
      startTimeRef.current = null;
    } else if (activeStory > 0) {
      setActiveStory((s) => s - 1);
      setSlideIndex(0);
      setProgress(0);
      startTimeRef.current = null;
    }
  }, [activeStory, slideIndex]);

  useEffect(() => {
    if (activeStory === null) return;
    const slide = stories[activeStory]?.slides[slideIndex];
    const isVideo = !!slide?.videoUrl;

    if (isVideo) {
      setVideoLoading(true);
      const tick = () => {
        const v = storyVideoRef.current;
        if (v && v.duration && !isNaN(v.duration) && v.duration > 0 && v.readyState >= 3) {
          setProgress(v.currentTime / v.duration);
        }
        timerRef.current = requestAnimationFrame(tick);
      };
      timerRef.current = requestAnimationFrame(tick);
    } else {
      setVideoLoading(false);
      startTimeRef.current = null;
      const tick = (ts) => {
        if (!startTimeRef.current) startTimeRef.current = ts;
        const elapsed = ts - startTimeRef.current;
        const pct = Math.min(elapsed / SLIDE_DURATION, 1);
        setProgress(pct);
        if (pct >= 1) {
          goNextSlide();
        } else {
          timerRef.current = requestAnimationFrame(tick);
        }
      };
      timerRef.current = requestAnimationFrame(tick);
    }
    return () => { if (timerRef.current) cancelAnimationFrame(timerRef.current); };
  }, [activeStory, slideIndex, stories, goNextSlide]);

  const handleStoryTap = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    if (x < rect.width * 0.3) goPrevSlide();
    else goNextSlide();
  };

  useEffect(() => {
    const allUrls = [];
    stories.forEach((story) => {
      const first = story.slides[0];
      if (first?.videoUrl) allUrls.push(first.videoUrl);
    });
    stories.forEach((story) => {
      story.slides.forEach((slide, i) => {
        if (i > 0 && slide.videoUrl && !allUrls.includes(slide.videoUrl)) {
          allUrls.push(slide.videoUrl);
        }
      });
    });

    if (allUrls.length === 0) return;

    const controller = new AbortController();
    const blobs = videoBlobsRef.current;

    const downloadAll = async () => {
      for (const url of allUrls) {
        if (controller.signal.aborted) break;
        if (blobs[url]) continue;
        try {
          const res = await fetch(url, { signal: controller.signal, mode: "cors" });
          if (!res.ok) continue;
          const blob = await res.blob();
          blobs[url] = URL.createObjectURL(blob);
        } catch {}
      }
    };

    downloadAll();

    return () => {
      controller.abort();
    };
  }, [stories]);

  const getVideoSrc = useCallback((url) => {
    return videoBlobsRef.current[url] || url;
  }, []);

  const openStory = (index) => {
    setActiveStory(index);
    setSlideIndex(0);
    setProgress(0);
    setVideoLoading(true);
    startTimeRef.current = null;

    const story = stories[index];
    if (story && story.slides) {
      story.slides.slice(0, 3).forEach(slide => {
        if (slide.imageUrl) {
          const img = new Image();
          img.src = slide.imageUrl;
          img.decode().catch(() => {});
        }
      });
    }
  };

  useEffect(() => {
    const token = store.getState()?.auth?.token;
    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
    if (!isAdmin) return undefined;
    const t = setTimeout(() => {
      if (shouldAutoOpenGenie()) setGenieOpen(true);
    }, 1800);
    return () => clearTimeout(t);
  }, [isAdmin]);

  const goTo = (redirectUrl) => {
    const token = store.getState()?.auth?.token;
    if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    navigate(redirectUrl);
  };

  const formatPrice = (price) =>
    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(price);

  const formatTimeRemaining = (endTime) => {
    const diff = new Date(endTime) - new Date();
    if (diff <= 0) return t.ended;
    const h = Math.floor(diff / 36e5);
    const m = Math.floor((diff % 36e5) / 6e4);
    if (h > 24) return `${Math.floor(h / 24)}d ${h % 24}h`;
    return `${h}h ${m}min`;
  };

  return (
    <div className="hlwg-root">
      <div className="hlwg-shell">
        {/* Top bar */}
        <div className="hlwg-topbar">
          <div className="hlwg-logo">
            <strong>Madamy</strong> Closet
          </div>
          <div className="hlwg-accent-line" />
          <div className="hlwg-avatar">
            <FontAwesomeIcon icon={faCrown} />
          </div>
        </div>

        {/* Stories */}
        <div className="hlwg-stories-row">
          <div className="hlwg-stories-refresh-hint">
            <FontAwesomeIcon icon={faRotate} />
            <span>Atualiza</span>
            <span>cada 24h</span>
          </div>
          {stories.map((story, i) => (
          <button
              key={story.id}
            type="button"
              className={`hlwg-story-thumb ${story.live ? "hlwg-story-thumb--live" : ""}`}
              onClick={() => openStory(i)}
            >
              <span
                className={`hlwg-story-ring ${story.live ? "hlwg-story-ring--live" : ""}`}
                style={{ background: story.gradient }}
              >
                <span className="hlwg-story-avatar">
                  <FontAwesomeIcon icon={story.icon} />
                </span>
            </span>
              <span className="hlwg-story-label">{story.label}</span>
              {story.live && (
                <span className="hlwg-story-live-tag">
                  <span className="hlwg-story-live-dot" />
                  {t.live}
            </span>
              )}
          </button>
          ))}
        </div>

        {/* 3 — Ticker: reforço de credibilidade */}
        <div className="hlwg-ticker-wrapper">
          <div className="hlwg-ticker-track">
            <span className="hlwg-ticker-content">
              {t.ticker}
            </span>
            <span className="hlwg-ticker-content" aria-hidden="true">
              {t.ticker}
            </span>
          </div>
        </div>

        {/* 2 — Hero */}
        <section className="hlwg-hero">
          <p className="hlwg-greeting">{t.greeting}</p>
          <h1 className="hlwg-title">
            {t.welcome} <span>{t.welcomeAccent}</span>
          </h1>
          <p className="hlwg-subtitle">
            {t.subtitle}
          </p>

          <button
            type="button"
            className="hlwg-cta"
            onClick={() => goTo(isSisterStore() ? "/shop" : "/dashboard")}
          >
            <FontAwesomeIcon icon={faTags} />
            {t.todayPromos}
            <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: "auto" }} />
          </button>
          {isAdmin ? (
          <button
            type="button"
            className="hlwg-genie-btn"
            onClick={() => setGenieOpen(true)}
          >
            <FontAwesomeIcon icon={faWandMagicSparkles} />
            {t.customizePromo}
          </button>
          ) : null}
        </section>

        {/* Info roleta — texto entre hero e leilões */}
        {(spinData?.spins_available > 0 || pendingPrize) && (
          <div className="hlwg-spin-info">
            {spinData?.spins_available > 0 && (
              <div onClick={() => navigate("/prize-wheel")}>
                <p className="hlwg-spin-info-line hlwg-spin-info-giro">
                  🎁 <strong>{t.spinLine(spinData.spins_available)}</strong> 🎁
                </p>
              </div>
            )}
            {pendingPrize && (
              <div onClick={() => {
                const isPhysical = pendingPrize.prize_key !== "frete_gratis" && !pendingPrize.prize_key.startsWith("desconto");
                if (isPhysical && (!myTestimonial || myTestimonial.status === "rejected")) {
                  openTestimonialWhatsApp(pendingPrize.prize_label);
                } else {
                  navigate("/prize-wheel");
                }
              }}>
                <p className="hlwg-spin-info-line hlwg-spin-info-prize">
                  {pendingPrize.prize_emoji} {t.nextBenefit} <strong>{pendingPrize.prize_key === "frete_gratis" ? t.freeShip : pendingPrize.prize_label}</strong> {t.nextBuy}
                </p>
                {pendingPrize.prize_key !== "frete_gratis" && !pendingPrize.prize_key.startsWith("desconto") && (!myTestimonial || myTestimonial.status === "rejected") && (
                  <p className="hlwg-spin-info-line hlwg-spin-info-alert">
                    ⚠️ {t.testimonialAlert}
                  </p>
                )}
              </div>
            )}
          </div>
        )}

        <div className="hlwg-banner-stack">
          {labOpen ? (
          <>
          <button
            type="button"
            className="hlwg-banner-row hlwg-banner-row--live"
            onClick={() => navigate("/auctions")}
          >
            <span className="hlwg-banner-icon hlwg-banner-icon--live">
              <FontAwesomeIcon icon={faGavel} />
            </span>
            <span className="hlwg-banner-info">
              <strong>{t.auctions}</strong>
              <small>
                {activeAuctions.length > 0
                  ? t.auctionsOpen(activeAuctions.length)
                  : endedTodayAuction
                    ? `${endedTodayAuction.winner_name || "Alguém"} levou · ${formatPrice(endedTodayAuction.winner_amount || endedTodayAuction.current_price)}`
                    : t.auctionsEmpty}
              </small>
            </span>
            <span className={`hlwg-live-badge ${endedTodayAuction && activeAuctions.length === 0 ? "hlwg-live-badge--ended" : ""}`}>
              {activeAuctions.length > 0 ? (
                <>
                  <span className="hlwg-live-dot" />
                  AO VIVO
                </>
              ) : endedTodayAuction ? (
                <>🏆 ENCERRADO</>
              ) : (
                "VER"
              )}
            </span>
          </button>

          {/* Cards de leilões ativos */}
          {activeAuctions.length > 0 && (
            <div className="hlwg-auction-cards">
              {activeAuctions.map((auc) => {
                const aId = auc._id || auc.id;
                return (
                  <button
                    key={aId}
                    type="button"
                    className="hlwg-auction-card"
                    onClick={() => navigate(`/auction/${aId}`)}
                  >
                    <div className="hlwg-auction-card-img">
                      <img
                        src={formatAuctionImageUrl(auc.images?.[0])}
                        alt={auc.title}
                        loading="lazy"
                        decoding="async"
                        onError={(e) => {
                          e.target.src = LUXURY_FALLBACK_IMAGE;
                        }}
                      />
                    </div>
                    <div className="hlwg-auction-card-info">
                      <strong>{auc.title}</strong>
                      <div className="hlwg-auction-card-prices-wrap" style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
                        <span className="hlwg-auction-card-price">{formatPrice(auc.current_price)}</span>
                        {auc.store_price && (
                          <span
                            className="hlwg-auction-card-store-price"
                            style={{ fontSize: 10, color: "#999", textDecoration: "line-through", fontWeight: 600 }}
                          >
                            Loja: {formatPrice(auc.store_price)}
                          </span>
                        )}
                      </div>
                      <span className="hlwg-auction-card-time">
                        <FontAwesomeIcon icon={faClock} style={{ marginRight: 4, fontSize: 10 }} />
                        {formatTimeRemaining(auc.end_time)}
                      </span>
                    </div>
                    <FontAwesomeIcon icon={faArrowRight} className="hlwg-auction-card-arrow" />
                  </button>
                );
              })}
              <button
                type="button"
                className="hlwg-auction-see-all"
                onClick={() => navigate("/auctions")}
              >
                {t.seeAllAuctions}
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          )}

          {/* Card encerrado hoje — só quando não tem ao vivo */}
          {activeAuctions.length === 0 && endedTodayAuction && (
            <div className="hlwg-auction-cards">
              <button
                type="button"
                className="hlwg-auction-card hlwg-auction-card--ended"
                onClick={() => navigate(`/auction/${endedTodayAuction._id || endedTodayAuction.id}`)}
              >
                <div className="hlwg-auction-card-img">
                  <img
                    src={formatAuctionImageUrl(endedTodayAuction.images?.[0])}
                    alt={endedTodayAuction.title}
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                      e.target.src = LUXURY_FALLBACK_IMAGE;
                    }}
                  />
                  <span className="hlwg-auction-ended-badge">🏆 Encerrado hoje</span>
                </div>
                <div className="hlwg-auction-card-info">
                  <strong>{endedTodayAuction.title}</strong>
                  <span className="hlwg-auction-card-winner">
                    <FontAwesomeIcon icon={faTrophy} style={{ marginRight: 4, fontSize: 10, color: "#B8962E" }} />
                    {endedTodayAuction.winner_name || "O maior lance"} levou
                  </span>
                  <span className="hlwg-auction-card-price">
                    {formatPrice(endedTodayAuction.winner_amount || endedTodayAuction.current_price)}
                  </span>
                </div>
                <FontAwesomeIcon icon={faArrowRight} className="hlwg-auction-card-arrow" />
              </button>
              <button
                type="button"
                className="hlwg-auction-see-all"
                onClick={() => navigate("/auctions")}
              >
                {t.seeAllAuctions}
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          )}
          </>
          ) : null}

          <button
            type="button"
            className="hlwg-banner-row hlwg-banner-row--news"
            onClick={() => navigate("/news")}
          >
            <span className="hlwg-banner-icon hlwg-banner-icon--news">
              <FontAwesomeIcon icon={faStar} />
            </span>
            <span className="hlwg-banner-info">
              <strong>{t.news}</strong>
              <small>{t.newsSub}</small>
            </span>
            <span className="hlwg-news-badge">NEW</span>
          </button>
        </div>

        {/* Super Promos — PT todas; EN só admin até o Rod listar o restante */}
        {showEnClient("superPromos", isAdmin) && <button
          type="button"
          className="hlwg-banner-row hlwg-banner-row--promo"
          onPointerEnter={() => { prefetchPromos(); import("./SuperPromos"); }}
          onTouchStart={() => { prefetchPromos(); import("./SuperPromos"); }}
          onClick={() => navigate("/super-promos")}
        >
          <span className="hlwg-banner-icon hlwg-banner-icon--promo">
            <FontAwesomeIcon icon={faFire} />
          </span>
          <span className="hlwg-banner-info">
            <strong>{t.superPromos}</strong>
            <small>{t.superPromosSub}</small>
          </span>
            <span className="hlwg-promo-badge">{t.newBadge}</span>
        </button>}

        {/* Receber Presente */}
        <button
          type="button"
          className="hlwg-gift-banner"
          onClick={() => navigate("/prize-wheel")}
        >
          <span className="hlwg-gift-icon-wrapper">
            <FontAwesomeIcon icon={faGift} />
          </span>
          <span className="hlwg-gift-text">
            <strong>{t.gift}</strong>
            <small>{t.giftSub}</small>
          </span>
          <FontAwesomeIcon icon={faArrowRight} className="hlwg-gift-arrow" />
        </button>

        {/* Enviar Depoimento */}
        <button
          type="button"
          className="hlwg-testimonial-banner"
          onClick={() => openTestimonialWhatsApp(pendingPrize?.prize_label)}
        >
          <span className="hlwg-testimonial-icon-wrapper">
            <FontAwesomeIcon icon={faWhatsapp} />
          </span>
          <span className="hlwg-testimonial-text">
            <strong>{t.testimonial}</strong>
            <small>{t.testimonialSub}</small>
          </span>
          <FontAwesomeIcon icon={faArrowRight} className="hlwg-testimonial-arrow" />
        </button>

        {/* Explorar */}
        <div className="hlwg-divider">{t.explore}</div>

        <div className="hlwg-grid" role="navigation" aria-label="Atalhos">
          {(
          <button
            type="button"
            className="hlwg-card"
              onClick={() => navigate("/points")}
          >
            <span className="hlwg-card-arrow">
              <FontAwesomeIcon icon={faArrowRight} />
            </span>
            <span className="hlwg-card-icon">
                <FontAwesomeIcon icon={faUserPlus} />
            </span>
              <p className="hlwg-card-label">{t.refer}</p>
              <p className="hlwg-card-desc">{t.referDesc}</p>
          </button>
          )}

          <button
            type="button"
            className="hlwg-card"
              onClick={() => navigate("/points")}
          >
            <span className="hlwg-card-arrow">
              <FontAwesomeIcon icon={faArrowRight} />
            </span>
            <span className="hlwg-card-icon">
                <FontAwesomeIcon icon={faTrophy} />
            </span>
              <p className="hlwg-card-label">{t.points}</p>
              <p className="hlwg-card-desc">{t.pointsDesc}</p>
          </button>

          <a
            className="hlwg-card"
            href={config.INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
          >
            <span className="hlwg-card-arrow">
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </span>
            <span className="hlwg-card-icon">
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </span>
            <p className="hlwg-card-label">{t.instagram}</p>
            <p className="hlwg-card-desc">{t.instagramDesc}</p>
          </a>

          <a
            className="hlwg-card"
            href={config.WEBSITE_URL}
            target="_blank"
            rel="noreferrer"
          >
            <span className="hlwg-card-arrow">
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </span>
            <span className="hlwg-card-icon">
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </span>
            <p className="hlwg-card-label">{t.website}</p>
            <p className="hlwg-card-desc">{t.websiteDesc}</p>
          </a>
        </div>

        {/* 7 — WhatsApp vendas */}
        <a
          className="hlwg-contact-bar"
          href={getVendasUrl()}
          target="_blank"
          rel="noreferrer"
        >
          <span>{t.talk}</span>
          <span className="hlwg-contact-link">
            <FontAwesomeIcon icon={faWhatsapp} />
            WhatsApp
          </span>
        </a>

        {/* Feedback */}
        <button
          type="button"
          className="hlwg-feedback-bar"
          onClick={() => { setFeedbackModal(true); setFeedbackSent(false); setFeedbackText(""); }}
        >
          <span>{t.feedback}</span>
          <span className="hlwg-feedback-link">
            <FontAwesomeIcon icon={faComments} />
            {t.send}
          </span>
        </button>

        {/* Instale o app */}
        <div className="hlwg-install">
          {t.install}
          <div className="hlwg-install-badges">
            <img
              src={googleplay}
              alt="Google Play"
              onClick={() => setAndroidModal(true)}
            />
            <img
              src={appstore}
              alt="App Store"
              onClick={() => setIosModal(true)}
            />
          </div>
        </div>
      </div>

      {/* Modal Android */}
      <Modal
        show={androidModal}
        onHide={() => setAndroidModal(false)}
        centered
        dialogClassName="hlwg-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t.installTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="hlwg-install-modal">
            <img src={android} alt="Android" className="hlwg-install-os-img" />
            <p className="hlwg-install-modal-text">
              {t.installAndroid}
            </p>
            <p className="hlwg-install-modal-platform">Android (Google Chrome)</p>
            <button
              type="button"
              className="hlwg-install-action-btn"
              onClick={() => setAndroidModal(false)}
            >
              <span>{t.installApp}</span>
              <img src={shareIconAndroid} alt="Share" className="hlwg-install-share-icon" />
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal iOS */}
      <Modal
        show={iosModal}
        onHide={() => setIosModal(false)}
        centered
        dialogClassName="hlwg-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t.installTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="hlwg-install-modal">
            <img src={ios} alt="iOS" className="hlwg-install-os-img hlwg-install-os-img--ios" />
            <p className="hlwg-install-modal-text">
              {t.installIos}
            </p>
            <p className="hlwg-install-modal-platform">iOS (Safari)</p>
          </div>

          <div className="hlwg-install-steps">
            <div className="hlwg-install-step">
              <span className="hlwg-step-number">01</span>
              <span className="hlwg-step-text">
                {t.step1}
              </span>
              <span className="hlwg-step-icon">
                <FontAwesomeIcon icon={faArrowUpFromBracket} />
              </span>
            </div>
            <div className="hlwg-install-step">
              <span className="hlwg-step-number">02</span>
              <span className="hlwg-step-text">
                {t.step2}
              </span>
              <span className="hlwg-step-icon">
                <FontAwesomeIcon icon={faPlusSquare} />
              </span>
            </div>
            <div className="hlwg-install-step">
              <span className="hlwg-step-number">03</span>
              <span className="hlwg-step-text">
                {t.step3}
              </span>
              <span className="hlwg-step-icon-btn">{t.add}</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Story Viewer Fullscreen */}
      {/* Modal Depoimento */}
      <Modal
        show={testimonialModal}
        onHide={() => setTestimonialModal(false)}
        centered
        dialogClassName="hlwg-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t.sendTestimonial}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingTestimonial ? (
            <div style={{ textAlign: "center", padding: "40px 0" }}>
              <FontAwesomeIcon icon={faSpinner} spin size="2x" color="#D4AF37" />
              <p style={{ marginTop: 16, color: "#888" }}>{t.loadingHistory}</p>
            </div>
          ) : myTestimonial && !testimonialSent && myTestimonial.status !== "rejected" ? (
            <div className="hlwg-feedback-success">
              <div className="hlwg-feedback-success-icon" style={{ 
                background: myTestimonial.status === 'approved' ? 'rgba(39,174,96,0.1)' : 'rgba(243,156,18,0.1)', 
                color: myTestimonial.status === 'approved' ? '#27ae60' : '#f39c12' 
              }}>
                <FontAwesomeIcon icon={myTestimonial.status === 'approved' ? faCheck : faClock} />
              </div>
              <h3>{myTestimonial.status === 'approved' ? t.approved : t.reviewing}</h3>
              <p>
                {myTestimonial.status === 'approved' ? t.approvedBody : t.reviewingBody}
              </p>
              
              <div style={{ margin: "16px 0", borderRadius: 8, overflow: "hidden", border: "1px solid #eee" }}>
                <video src={myTestimonial.video_url} controls style={{ width: "100%", maxHeight: 200, display: "block", backgroundColor: "#000" }} />
              </div>
              
              <p style={{ fontSize: 12, color: "#999", marginBottom: 16 }}>{t.sentOn}: {new Date(myTestimonial.created_at).toLocaleDateString(config.STORE_LOCALE === "en" ? "en-US" : "pt-BR")}</p>
              
              <button
                type="button"
                className="hlwg-cta"
                style={{ animation: "none" }}
                onClick={() => setTestimonialModal(false)}
              >
                {t.close}
              </button>
            </div>
          ) : testimonialSent ? (
            <div className="hlwg-feedback-success">
              <div className="hlwg-feedback-success-icon">
                <FontAwesomeIcon icon={faVideo} />
              </div>
              <h3>{t.testimonialSent}</h3>
              <p>{t.testimonialSentBody}</p>
              <button
                type="button"
                className="hlwg-cta"
                style={{ animation: "none" }}
                onClick={() => setTestimonialModal(false)}
              >
                {t.close}
              </button>
            </div>
          ) : (
            <div className="hlwg-feedback-form">
              <p className="hlwg-feedback-desc">
                {t.testimonialDesc}
              </p>

              <div className="hlwg-testimonial-rules">
                <div className="hlwg-testimonial-rule">
                  <span className="hlwg-testimonial-rule-num">1</span>
                  <span>{t.rule1}</span>
                </div>
                <div className="hlwg-testimonial-rule">
                  <span className="hlwg-testimonial-rule-num">2</span>
                  <span>{t.rule2}</span>
                </div>
                <div className="hlwg-testimonial-rule">
                  <span className="hlwg-testimonial-rule-num">3</span>
                  <span>{t.rule3}</span>
                </div>
              </div>

              <button
                type="button"
                className="hlwg-cta"
                style={{ animation: "none", background: "linear-gradient(135deg, #25D366, #128C7E)", marginTop: 16 }}
                onClick={() => openTestimonialWhatsApp(pendingPrize?.prize_label)}
              >
                <FontAwesomeIcon icon={faWhatsapp} /> {t.openWa}
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal Feedback */}
      <Modal
        show={feedbackModal}
        onHide={() => setFeedbackModal(false)}
        centered
        dialogClassName="hlwg-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t.feedback}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {feedbackSent ? (
            <div className="hlwg-feedback-success">
              <div className="hlwg-feedback-success-icon">
                <FontAwesomeIcon icon={faHeart} />
              </div>
              <h3>{t.thanksFeedback}</h3>
              <p>{t.thanksFeedbackBody}</p>
              <button
                type="button"
                className="hlwg-cta"
                style={{ animation: "none" }}
                onClick={() => setFeedbackModal(false)}
              >
                {t.close}
              </button>
            </div>
          ) : (
            <div className="hlwg-feedback-form">
              <p className="hlwg-feedback-desc">
                {t.feedbackDesc}
              </p>
              <textarea
                className="hlwg-feedback-textarea"
                rows={4}
                placeholder={t.feedbackPh}
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
              />
              <button
                type="button"
                className="hlwg-cta"
                style={{ animation: "none" }}
                disabled={!feedbackText.trim()}
                onClick={() => setFeedbackSent(true)}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
                {t.sendFeedback}
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {activeStory !== null && stories[activeStory] && (() => {
        const currentSlide = stories[activeStory].slides[slideIndex];
        const isVideo = !!currentSlide?.videoUrl;
        const isAuction = !!currentSlide?.auction;
        return (
          <div className="hlwg-story-viewer" onClick={handleStoryTap}>
            {isVideo ? (
              <>
                <video
                  ref={storyVideoRef}
                  key={`${activeStory}-${slideIndex}`}
                  src={getVideoSrc(currentSlide.videoUrl)}
                  autoPlay
                  muted={storyMuted}
                  playsInline
                  preload="auto"
                  onCanPlay={() => setVideoLoading(false)}
                  onPlaying={() => setVideoLoading(false)}
                  onWaiting={() => setVideoLoading(true)}
                  onEnded={goNextSlide}
                  onError={goNextSlide}
                  className="hlwg-story-video"
                />
                <div className="hlwg-story-bg hlwg-story-bg--video" />
                {videoLoading && (
                  <div className="hlwg-story-loading">
                    <div className="hlwg-story-loading-spinner" />
                    <span className="hlwg-story-loading-text">{t.loadingDots}</span>
                  </div>
                )}
              </>
            ) : isAuction ? (
              <div className="hlwg-story-bg hlwg-story-bg--auction">
                {currentSlide.imageUrl && (
                  <img
                    src={currentSlide.imageUrl}
                    alt={currentSlide.title}
                    className="hlwg-story-auction-img"
                    fetchpriority="high"
                    decoding="sync"
                  />
                )}
              </div>
            ) : (
              <div
                className="hlwg-story-bg"
                style={{ background: currentSlide.bg }}
              />
            )}

            {/* Progress bars */}
            <div className="hlwg-story-progress-row">
              {stories[activeStory].slides.map((_, i) => (
                <div key={i} className="hlwg-story-progress-track">
                  <div
                    className="hlwg-story-progress-fill"
                    style={{
                      width:
                        i < slideIndex
                          ? "100%"
                          : i === slideIndex
                          ? `${progress * 100}%`
                          : "0%",
                      transition: i === slideIndex ? "none" : "width 0.2s",
                    }}
                  />
                </div>
              ))}
            </div>

            {/* Header */}
            <div className="hlwg-story-header">
              <div className="hlwg-story-header-info">
                <span
                  className="hlwg-story-header-avatar"
                  style={{ background: stories[activeStory].gradient }}
                >
                  <FontAwesomeIcon icon={stories[activeStory].icon} />
                </span>
                <span className="hlwg-story-header-name">
                  {stories[activeStory].label}
                </span>
              </div>
              {isVideo && (
                <button
                  type="button"
                  className="hlwg-story-mute"
                  onClick={(e) => {
                    e.stopPropagation();
                    const next = !storyMuted;
                    setStoryMuted(next);
                    if (storyVideoRef.current) storyVideoRef.current.muted = next;
                  }}
                >
                  <FontAwesomeIcon icon={storyMuted ? faVolumeMute : faVolumeUp} />
                </button>
              )}
              <button
                type="button"
                className="hlwg-story-close"
                onClick={(e) => { e.stopPropagation(); closeStory(); }}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            {/* Auction slide content */}
            {isAuction && (
              <div className="hlwg-story-auction-content" onClick={(e) => e.stopPropagation()}>
                <div className="hlwg-story-auction-badge">
                  <FontAwesomeIcon icon={faGavel} />
                  <span>{t.liveAuction}</span>
                </div>
                <h2 className="hlwg-story-auction-title">{currentSlide.title}</h2>
                <div className="hlwg-story-auction-price">
                  <span className="hlwg-story-auction-price-label">{t.currentBid}</span>
                  <div className="hlwg-story-auction-price-row" style={{ display: "flex", alignItems: "baseline", gap: 10, justifyContent: "center" }}>
                    <span className="hlwg-story-auction-price-value">
                      R$ {Number(currentSlide.price).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                    </span>
                    {currentSlide.storePrice && (
                      <span
                        className="hlwg-story-auction-store-crossed"
                        style={{ fontSize: 13, fontWeight: 600, color: "rgba(255,255,255,.7)", textDecoration: "line-through" }}
                      >
                        Loja: R$ {Number(currentSlide.storePrice).toLocaleString("pt-BR", { minimumFractionDigits: 0 })}
                      </span>
                    )}
                  </div>
                </div>
                <div className="hlwg-story-auction-meta">
                  <span><FontAwesomeIcon icon={faClock} /> {formatTimeRemaining(currentSlide.endTime)}</span>
                  <span><FontAwesomeIcon icon={faUsers} /> {currentSlide.totalBids} {t.bids}</span>
                </div>
                <button
                  type="button"
                  className="hlwg-story-auction-cta"
                  onClick={() => {
                    closeStory();
                    navigate("/auctions");
                  }}
                >
                  <FontAwesomeIcon icon={faGavel} />
                  {t.seeAuctions}
                </button>
              </div>
            )}

            {/* Text content (only for non-video, non-auction slides) */}
            {!isVideo && !isAuction && (
              <div className="hlwg-story-content" onClick={(e) => e.stopPropagation()}>
                <div className="hlwg-story-slide-icon">
                  <FontAwesomeIcon icon={currentSlide.icon} />
                </div>
                <h2 className="hlwg-story-slide-title">
                  {currentSlide.title}
                </h2>
                {currentSlide.stars && (
                  <div className="hlwg-story-stars">
                    {Array.from({ length: currentSlide.stars }).map((_, i) => (
                      <FontAwesomeIcon key={i} icon={faStarSolid} />
                    ))}
                  </div>
                )}
                <p className="hlwg-story-slide-text">
                  {currentSlide.text}
                </p>
              </div>
            )}

            {/* Tap zones */}
            <div
              className="hlwg-story-tap-left"
              onClick={(e) => { e.stopPropagation(); goPrevSlide(); }}
            />
            <div
              className="hlwg-story-tap-right"
              onClick={(e) => { e.stopPropagation(); goNextSlide(); }}
            />
          </div>
        );
      })()}
      <PromoGenieModal
        open={isAdmin && genieOpen}
        onClose={() => setGenieOpen(false)}
        destination="/dashboard"
        onApplied={({ destination }) => {
          try {
            sessionStorage.removeItem("sp_promos_v1");
          } catch {}
          const token = store.getState()?.auth?.token;
          if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;
          setGenieOpen(false);
          navigate(destination || "/dashboard");
        }}
      />
      <TesteeAppDock />
    </div>
  );
};

export default HomeLuxWhiteGold;
